import styled from 'styled-components';
import { Radio } from 'components/RadioGroup';
import { Bar } from 'components/RadioGroup/styles';
import { grey2 } from 'styles/colors';
import {
	ApButtonSecondary,
	colors,
	ApModal,
} from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	max-width: 450px;
`;

export const Content = styled.div`
	padding: 0 16px;
	position: relative;
`;

export const SubheaderSection = styled.div`
	margin: -16px -16px 16px -16px;
	padding: 24px 32px;
	background-color: ${grey2};
`;

export const SubheaderText = styled.div`
	font-size: 19px;
	color: ${colors.black};
	font-weight: bold;
	padding: 0 !important;
`;

export const SubheaderHelper = styled.div`
	font-size: 11px;
	margin: 12px 0px;
	color: ${colors.grey5};
`;

export const SubheaderTags = styled.div`
	display: flex;
	flex-wrap: wrap;

	> div {
		background-color: white;
		margin-bottom: 8px;
	}
`;

export const SectionTitle = styled.div`
	color: ${colors.black};
	padding: 12px 0;
	font-size: 19px;
`;

export const Section = styled.div`
	&:last-child {
		margin-top: 16px;
	}
`;

export const StyledRadio = styled(Radio)`
	font-size: 16px;
	color: ${colors.black};

	${Bar} {
		padding: 8px 16px;
		min-height: 24px;
	}
`;

export const StyledButtonSecondary = styled(ApButtonSecondary)`
	margin-right: 32px;
`;

export const StyledModal = styled(ApModal)`
	.ap-modal-content {
		max-height: 100%;
	}

	.ap-modal-header {
		border-color: ${grey2};
	}

	.ap-modal-footer {
		${({ isLoading }) => isLoading && 'border-color: transparent;'};
	}
`;

export const LoadingWrapper = styled.div`
	position: absolute;
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	background-color: white;
	z-index: 2;
`;

export const LoadingFooter = styled.div`
	height: 36px;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${colors.green1};
	font-size: 13px;
	letter-spacing: 0.3px;
`;
